module.exports = __webpack_public_path__ + "img/redEnvelopes.c15b93f9.png";